// extracted by mini-css-extract-plugin
export default {"title":"style_title__aSfGz","text":"style_text__yGNBp","txHash":"style_txHash__JTZ4S"};